var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlotteOgHerregarde = function SvgSlotteOgHerregarde(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeMiterlimit: 10,
    d: "M14.83 6.383v6.75H1.17v-6.75m9.397 6.75V6.387m-5.135 6.746V6.387m1.306 6.587v-2.722c0-.693.57-1.262 1.262-1.262s1.262.57 1.262 1.262v2.722M2.626 7.706h1.359v1.42H2.626zm0 2.687h1.359v1.42H2.626zm6.12-3.477a.746.746 0 1 1-1.492 0 .746.746 0 0 1 1.491 0Zm3.657-4.376H3.597L.5 5.32v1.063h4.932L8 3.815l2.568 2.568H15.5V5.319zm-.376 5.166h1.36v1.42h-1.36zm0 2.687h1.36v1.42h-1.36z"
  })));
};
export default SvgSlotteOgHerregarde;